import { Stack } from '@mui/material';
import { SummaryBody, viewDefinitions } from './SummaryView/SummaryBody';
import { CampaignPulseCard } from './CampaignPulse/CampaignPulseCard';
import { Lci3Report } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { NotReady } from './SummaryView/Sales/NotReady';
import { Upsell } from './SummaryView/Sales/Upsell';
import { memo } from 'react';

type SummaryProps = {
  campaign: Parameters<
    typeof viewDefinitions.sales.renderComponent
  >[0]['campaign'] & {
    salesEnabled: boolean;
    salesRequested: boolean;
  };
  selectedReport: Lci3Report;
  latestSalesReport?: Lci3Report;
  allReports: Lci3Report[];
};

export const Summary = memo((props: SummaryProps) => {
  const rsaViewComponent = () => {
    if (!props.campaign.salesEnabled) {
      return (
        <Upsell
          campaignId={props.campaign.id}
          requested={props.campaign.salesRequested}
        />
      );
    }
    if (!props.latestSalesReport?.salesMetrics) {
      return <NotReady />;
    }

    return viewDefinitions.sales.renderComponent({
      ...props,
      salesMetrics: props.latestSalesReport.salesMetrics,
      reportDate: props.latestSalesReport.reportDate,
    });
  };

  const rsaView = {
    label: 'Sales',
    Component: rsaViewComponent(),
  };
  const visitView = {
    label: 'Visit',
    Component: viewDefinitions.visit.renderComponent({
      ...props,
    }),
  };

  return (
    <Stack direction="column" gap="1rem" flexWrap="wrap">
      <CampaignPulseCard
        selectedReport={props.selectedReport}
        latestSalesReport={props.latestSalesReport}
      />

      <SummaryBody
        views={[rsaView, visitView]}
        defaultView={props.latestSalesReport ? rsaView : visitView}
      />
    </Stack>
  );
});

Summary.displayName = 'Summary';
